// Configuración de toasts mejorados con sonner - Diseño moderno y atractivo
import { toast } from 'sonner';

// Custom toast con botón de cerrar y estilos mejorados
export const showToast = {
  success: (message, options = {}) => {
    return toast.success(message, {
      duration: 3000,
      dismissible: true,
      closeButton: true,
      style: {
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: 'white',
        border: 'none',
        padding: '16px 20px',
        borderRadius: '16px',
        boxShadow: '0 8px 32px rgba(16, 185, 129, 0.4), 0 2px 8px rgba(0, 0, 0, 0.1)',
        fontWeight: '500',
        fontSize: '15px',
        backdropFilter: 'blur(10px)',
      },
      ...options,
    });
  },

  error: (message, options = {}) => {
    return toast.error(message, {
      duration: 5000,
      dismissible: true,
      closeButton: true,
      style: {
        background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
        color: 'white',
        border: 'none',
        padding: '16px 20px',
        borderRadius: '16px',
        boxShadow: '0 8px 32px rgba(239, 68, 68, 0.4), 0 2px 8px rgba(0, 0, 0, 0.1)',
        fontWeight: '500',
        fontSize: '15px',
        backdropFilter: 'blur(10px)',
      },
      ...options,
    });
  },

  info: (message, options = {}) => {
    return toast.info(message, {
      duration: 4000,
      dismissible: true,
      closeButton: true,
      style: {
        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
        color: 'white',
        border: 'none',
        padding: '16px 20px',
        borderRadius: '16px',
        boxShadow: '0 8px 32px rgba(59, 130, 246, 0.4), 0 2px 8px rgba(0, 0, 0, 0.1)',
        fontWeight: '500',
        fontSize: '15px',
        backdropFilter: 'blur(10px)',
      },
      ...options,
    });
  },

  warning: (message, options = {}) => {
    return toast.warning(message, {
      duration: 4000,
      dismissible: true,
      closeButton: true,
      style: {
        background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        color: 'white',
        border: 'none',
        padding: '16px 20px',
        borderRadius: '16px',
        boxShadow: '0 8px 32px rgba(245, 158, 11, 0.4), 0 2px 8px rgba(0, 0, 0, 0.1)',
        fontWeight: '500',
        fontSize: '15px',
        backdropFilter: 'blur(10px)',
      },
      ...options,
    });
  },

  promise: (promise, messages, options = {}) => {
    return toast.promise(promise, {
      loading: messages.loading || 'Cargando...',
      success: messages.success || 'Completado',
      error: messages.error || 'Error',
      ...options,
    });
  },
};

// Configuración global del Toaster - Estilos modernos y atractivos
export const toasterConfig = {
  position: 'bottom-center',
  expand: false,
  richColors: false,
  closeButton: true,
  duration: 3000,
  toastOptions: {
    style: {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      border: 'none',
      padding: '16px 20px',
      borderRadius: '16px',
      boxShadow: '0 8px 32px rgba(102, 126, 234, 0.4), 0 2px 8px rgba(0, 0, 0, 0.1)',
      fontWeight: '500',
      fontSize: '15px',
      backdropFilter: 'blur(10px)',
    },
    // Estilos para los diferentes tipos de toast cuando se usa toast() directamente
    success: {
      style: {
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        boxShadow: '0 8px 32px rgba(16, 185, 129, 0.4), 0 2px 8px rgba(0, 0, 0, 0.1)',
      },
    },
    error: {
      style: {
        background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
        boxShadow: '0 8px 32px rgba(239, 68, 68, 0.4), 0 2px 8px rgba(0, 0, 0, 0.1)',
      },
    },
    info: {
      style: {
        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
        boxShadow: '0 8px 32px rgba(59, 130, 246, 0.4), 0 2px 8px rgba(0, 0, 0, 0.1)',
      },
    },
    warning: {
      style: {
        background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        boxShadow: '0 8px 32px rgba(245, 158, 11, 0.4), 0 2px 8px rgba(0, 0, 0, 0.1)',
      },
    },
  },
};
